import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram } from 'lucide-react';

const Footer = () => {
  const clubLogo = "https://customer-assets.emergentagent.com/job_cafc-platform/artifacts/d9rcitex_OurLogo.png";

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Club Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img 
                src={clubLogo} 
                alt="Crawley Athletic FC" 
                className="h-12 w-12"
              />
              <div>
                <h3 className="text-2xl font-bold">Crawley Athletic</h3>
                <p className="text-gray-300">Football Club</p>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Crawley Athletic FC offers open-access football for players of all abilities and builds a welcoming, inclusive community for them and their families.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <Facebook className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <Twitter className="h-6 w-6" />
              </a>
              <a href="#" className="text-gray-300 hover:text-white transition-colors">
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/squad" className="text-gray-300 hover:text-white transition-colors">
                  Squad & Staff
                </Link>
              </li>
              <li>
                <Link to="/fixtures" className="text-gray-300 hover:text-white transition-colors">
                  Fixtures & Results
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-gray-300 hover:text-white transition-colors">
                  Club Shop
                </Link>
              </li>
              <li>
                <Link to="/sponsors" className="text-gray-300 hover:text-white transition-colors">
                  Our Sponsors
                </Link>
              </li>
              <li>
                <Link to="/join-us" className="text-gray-300 hover:text-white transition-colors">
                  Join The Club
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-gray-400" />
                <a 
                  href="mailto:info@crawleyafc.uk" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  info@crawleyafc.uk
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-gray-400" />
                <a 
                  href="mailto:sales@crawleyafc.uk" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  sales@crawleyafc.uk
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-gray-400 mt-0.5" />
                <div>
                  <p className="text-gray-300">Crawley Athletic FC Stadium</p>
                  <p className="text-gray-300">Crawley, West Sussex</p>
                  <p className="text-gray-300">United Kingdom</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2025 Crawley Athletic Football Club. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;